import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSession } from '@/lib/session';
import { visibleMenus } from '@/admin/selectors';
import { useAdminStore } from '@/admin/adminStore';
import { Avatar } from '@/components/ui/Avatar';
import { Icon } from '@/components/ui/Icon';
import styles from './Sidebar.module.css';

import { BrandMark } from '@/components/ui/BrandMark';

export function Sidebar() {
  const { user, role, logout } = useSession();
  const navigate = useNavigate();
  const store = useAdminStore();

  function handleLogout() {
    navigate('/login', { replace: true });
    logout();
  }

  const items = role ? visibleMenus(role, store) : [];
  const homePath = role ? `/${role}` : '/';

  return (
    <aside className={styles.sidebar} aria-label="Main Navigation">
      {/* Brand Header */}
      <div className={styles.brand}>
        <NavLink to={homePath} className={styles.brandLink}>
          <BrandMark size="md" />
        </NavLink>
      </div>

      {/* Nav List */}
      <nav className={styles.nav}>
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
            }
          >
            {item.icon && <Icon name={item.icon} size={20} className={styles.navIcon} />}
            <span className={styles.navLabel}>{item.label}</span>
          </NavLink>
        ))}

        <div className={styles.divider} />

        <NavLink
          to="/_kit"
          className={({ isActive }) =>
            `${styles.navItem} ${styles.kitItem} ${isActive ? styles.navItemActive : ''}`
          }
        >
          <Icon name="chart" size={18} />
          <span className={styles.navLabel}>Component Kit</span>
        </NavLink>
      </nav>

      {/* User Card at Bottom */}
      {user && (
        <div className={styles.userFooter}>
          <div className={styles.userRow}>
            <Avatar name={user.name} size="md" />
            <div className={styles.userInfo}>
              <span className={styles.userName}>{user.name}</span>
              <span className={styles.userRole}>{user.role}</span>
            </div>
          </div>
          <button
            type="button"
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Sign out"
            aria-label="Sign out"
          >
            <Icon name="logout" size={18} />
          </button>
        </div>
      )}
    </aside>
  );
}
